import api from "../../axiosConfig";

export const addShift = async (formData) => {

    try {

      const response = await api.post('/doctor-shift/add-shift', formData);
      const resData = response?.data;
      console.log('Response data:', resData);
  
      if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
        return { success: true, data: resData };
      } else {
        return { success: false, error: resData.message };
      }
    } catch (err) {
      throw new Error(err.response?.data?.message || 'Login error');
    }
  };


export const getShifts = async (doctor_id,date) => {
  try {
    const response = await api.get('/doctor-shift/all-shift', {
      params: {
        doctor_id: doctor_id,
        date: date, // Pass the date parameter
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching SHifts');
  }
};

export const updateShifts = async (id, formData) => {

  const payload = {
    ...formData,
    id: parseInt(id),
    _method: 'put', // Required for Laravel-style method spoofing
  };
  console.log('Payload for update:', payload);

  try {
    const response = await api.post(`/doctor-shift/update-shift/${id}`, payload);

    const resData = response?.data;
    console.log('Update shifts response:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error updating shift');
  }
};

export const getdoctor = async (hospital_id) => {
  const token = sessionStorage.getItem('token');

  try {
    const response = await api.get('/doctor/all-doctor', {
      params: {
        hospital_id: hospital_id
      },
    });

    const resData = response?.data;
    console.log('Response data:', resData);

    if (resData?.success_type === 'success'|| resData?.message_type === 'success') {
      return { success: true, data: resData?.data };
    } else {
      return { success: false, error: resData.message };
    }
  } catch (err) {
    throw new Error(err.response?.data?.message || 'Error fetching doctors');
  }
};